// extracted by mini-css-extract-plugin
export default {"root":"ProjectIndex_root__rRQC3","filter":"ProjectIndex_filter__W423V","projectArea":"ProjectIndex_projectArea__VRXtB","noContent":"ProjectIndex_noContent__OBwEB"};